import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContentForm } from "@iddataweb/idw-common-ui/types";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";

type workflowDetailsAttributePlaceholderProps = {
    isDisabled: boolean;
    attribute: FormattedRpServiceConfigurationAttribute;
    attrField: { key: keyof AXNUIContentForm, label: string, value: string };
    handleAttributeFieldChange: (attributeTypeName: AttributeTypes, key: keyof AXNUIContentForm, newValue: string) => void;
    validationErrors?: React.ReactNode;
}

export const WorkflowDetailsAttributePlaceholder = (props: workflowDetailsAttributePlaceholderProps) => {
    const { isDisabled, attribute, attrField, handleAttributeFieldChange } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleAttributeFieldChange(attribute.attributeType.name, attrField.key, event.target.value);
    }

    return (
        <InputFormGroup
            controlId={`attributeID-${attribute.attributeType?.id}-uuid-${attribute.uuid}-placeholder-${attrField.key}`}
            key={`attributeID-${attribute.attributeType?.id}-uuid-${attribute.uuid}-placeholder-${attrField.key}`}
            label={attrField.label}
            ariaLabel={attrField.label}
            value={attrField.value}
            disabled={isDisabled}
            isRequired={true}
            labelWidth={LabelWidthTypes.MEDIUM}
            onChange={handleChange}
        />
    );
}